import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppConfigService } from '@core/appconfig.service';
import { translateHttpLoaderFactory } from '@core/core.module';
import { DefaultTranslationProvider } from '@core/default-translation.provider';
import { LOCALE_ROLE } from '@core/translate-api.loader';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/button/button.component';
import { PreloaderModule } from '@shared/preloader/preloader.module';
import { SharedModule } from '@shared/shared.module';

import { ZbpIconComponent } from '@shared/zbp-icon/zbp-icon';
import { BrandedLoginComponent } from './branded-login/branded-login.component';
import { LoginFormComponent } from './branded-login/login-form/login-form.component';
import { BrandedQrCodeLoginComponent } from './branded-login/qr-code-aside/branded-qr-code-login.component';
import { SsoFormComponent } from './branded-login/sso-form/sso-form.component';
import {
  RedesignedChooseLoginComponent
} from './choose-login/redesigned-choose-login/redesigned-choose-login.component';
import { RoleButtonComponent } from './choose-login/redesigned-choose-login/role-button/role-button.component';
import { InvalidTokenComponent } from './invalid-token/invalid-token.component';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { SkofLoginComponent } from './login.skof/login.skof.component';
import { LoginSsoComponent } from './login.sso/login.sso.component';
import { LtiTokenExchangeComponent } from './lti-token-exchange/lti-token-exchange.component';
import { OAuth2Component } from './oauth2/oauth2.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ZbpIconComponent,
    ButtonComponent,
    PreloaderModule,
    LoginRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrandedQrCodeLoginComponent,
    TranslateModule.forChild({
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: DefaultTranslationProvider,
      },
      loader: {
        provide: TranslateLoader,
        useFactory: (translateHttpLoaderFactory),
        deps: [HttpClient, AppConfigService, LOCALE_ROLE],
      },
      isolate: true,
    }),
  ],
  declarations: [
    SkofLoginComponent,
    RoleButtonComponent,
    RedesignedChooseLoginComponent,
    LoginComponent,
    InvalidTokenComponent,
    LtiTokenExchangeComponent,
    OAuth2Component,
    LoginSsoComponent,
    BrandedLoginComponent,
    SsoFormComponent,
    LoginFormComponent
  ],
  providers: [
    { provide: LOCALE_ROLE, useValue: null },
  ],
  exports: [
    SkofLoginComponent,
    LoginComponent,
    LoginSsoComponent,
    BrandedQrCodeLoginComponent,
  ]
})
export class LoginModule { }
